import './App.css';
import { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import Landing from './routes/Landing';
/* import Productos from './routes/Productos'; */
import Rodilleras from './routes/Rodilleras';
import Cinturones from './routes/Cinturones';
import Muñequeras from './routes/Muñequeras';
import Singlets from './routes/Singlets';
import Vendas from './routes/Vendas';
import Calzado from './routes/Calzado';
import Politicas from './routes/Politicas';
import RodillerasRigidas from './routes/Rodilleras-rig';
import ProductDetail from "./routes/ProductDetail";
import Colecciones from './routes/Colecciones';
import ComoEncargar from './routes/ComoEncargar';
import NotFound from "./routes/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { captureLeadSource } from "./utils/waSource";


function App() {
  useEffect(() => {
    captureLeadSource();
  }, []);

  return (
    <BrowserRouter>
    <ScrollToTop/>
    <Routes>
      <Route path="/" element={<Landing/>} />
{/*       <Route path="/productos" element={<Productos/>}/> */}
      <Route path="/rodilleras" element={<Rodilleras/>}/>
      <Route path="/rodilleras-rig" element={<RodillerasRigidas/>}/>
      <Route path="/cinturones" element={<Cinturones/>}/>
      <Route path="/singlets" element={<Singlets/>}/>
      <Route path="/muñequeras" element={<Muñequeras/>}/>
      <Route path="/vendas" element={<Vendas/>}/>
      <Route path="/calzado" element={<Calzado/>}/>
      <Route path="/politicas" element={<Politicas/>}/>
      <Route path="/producto/:slug" element={<ProductDetail />} />
      <Route path="/colecciones" element={<Colecciones/>}/>
      <Route path="/comoencargar" element={<ComoEncargar/>}/>
      <Route path="*" element={<NotFound/>} />
    </Routes>
    <FloatingWhatsApp />
  </BrowserRouter>
  );
}

export default App;
